var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHistory(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    viewBox: "0 0 16.5 16.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.25, -1.35) scale(0.97)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M16.417 9.583A7.917 7.917 0 1 1 8.5 1.666a7.917 7.917 0 0 1 7.917 7.917zm-2.787.06a5.076 5.076 0 0 0-7.6-4.401 5.11 5.11 0 0 0-1.252 1.015V5.57a.396.396 0 0 0-.792 0v1.66a.396.396 0 0 0 .396.395H6.04a.396.396 0 0 0 0-.791h-.717A4.274 4.274 0 0 1 8.556 5.36a4.282 4.282 0 1 1-4.283 4.283.396.396 0 0 0-.792 0 5.074 5.074 0 1 0 10.15 0zm-4.763-.099V6.872a.396.396 0 0 0-.791 0v2.841a.395.395 0 0 0 .153.313l1.537 1.536a.396.396 0 1 0 .56-.56z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHistory);
export default __webpack_public_path__ + "static/media/history.e3116f0b66f3d741e7975381f592b284.svg";
export { ForwardRef as ReactComponent };